import cn from 'classnames';
import type { Image } from 'models';
import { Avatar, Flex, Icon, Text } from 'ui';

type P = {
  className?: string;
  onClick: () => void;
  placeholder: string;
  profilePhoto?: Image;
};

const PlaceholderTrigger = ({ className, onClick, placeholder, profilePhoto }: P) => (
  <Flex align="center" className={cn('placeholder-trigger', className)} justify="space-between" onClick={onClick}>
    <Flex align="center" gap="ms">
      <Avatar size="lg" src={profilePhoto} />
      <Text>{placeholder}</Text>
    </Flex>
    <Icon icon="attachment-line" />
  </Flex>
);

export default PlaceholderTrigger;
